import { useContext } from 'react';
import { readableContext, ReadableContext } from './readable-context';

export const useReadableContext = () => {
	return useContext<ReadableContext>(readableContext);
};
